import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default Vue.component('link-page', {
  template: require('./template.html'),
  name: 'link-page',
  computed: {
    ...mapGetters(['currentSite', 'currentPage']),
    allPages() {
      const range = [{ name: 'No Link' }, { name: 'Custom Link' }];
      const { pages } = this.currentSite;
      const published = pages.filter(page => page.status !== 'unpublished');
      _.forEach(published, (page) => {
        range.push({
          _id: page._id,
          name: page.name,
          url: page.url,
        });
      });
      const search = new RegExp(this.searchPages, 'gi');
      return _.filter(range, p => p.name.match(search));
    },
  },
  props: [
    'droplet',
    'show-edit-bubble',
    'fallback',
    'optional',
  ],
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
  },
  data() {
    return {
      showPages: false,
      searchPages: '',
      pageLink: '',
      customLink: '',
      newWindow: false,
    };
  },
  created() {
    this.setInitialValues();
  },
  methods: {
    setInitialValues() {
      const values = [];
      if (typeof this.droplet.hasLink === 'undefined' && this.optional) {
        values.push({
          key: 'hasLink',
          value: false,
        });
      }
      if (typeof this.droplet.newWindow === 'undefined') {
        values.push({
          key: 'newWindow',
          value: false,
        });
      }
      if (typeof this.droplet.pageLink === 'undefined') {
        values.push(
          {
            key: 'pageLink',
            value: this.droplet[this.fallback] || false,
          },
          {
            key: 'customLink',
            value: this.droplet[this.fallback] || false,
          },
        );
      }
      if (values.length > 0) {
        this.$store.dispatch('setNewDropletValues', {
          vm: this,
          drp: this.droplet,
          values,
        });
      }
      this.customLink = this.droplet.customLink || '';
      this.pageLink = this.getPageLink();
      this.newWindow = this.droplet.newWindow;
    },
    updatePageLink(page) {
      let pagelink = false;
      this.pageLink = page.name;
      if (page.name === 'Custom Link') {
        pagelink = this._getInputVal(this.customLink);
      }
      if (page._id) {
        pagelink = page._id;
      }
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key: 'pageLink',
        val: pagelink,
      });
      this.showPages = false;
    },
    updateCustomLink(link) {
      const val = this._getInputVal(link);
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key: 'pageLink',
        val,
      });
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key: 'customLink',
        val,
      });
    },
    updateNewWindow() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key: 'newWindow',
        val: this.newWindow,
      });
    },
    getPageLink() {
      const currentPageLink = this.droplet.pageLink;
      let link = '';
      if (!currentPageLink) {
        link = 'No Link';
      }
      const pageId = new RegExp(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/, 'i');
      if (typeof currentPageLink === 'string') {
        // we know it's linked to a page here
        if (currentPageLink.match(pageId) && !currentPageLink.match(/^#modal-/i)) {
          const page = _.find(this.allPages, p => p._id === currentPageLink);
          if (page) {
            link = page.name;
          } else {
            // if it's get here, it's likely because the page was deleted
            link = 'No Link';
          }
        } else {
          link = 'Custom Link';
        }
      }
      return link;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/_bubble-options/components/link-page/index.js